import {
  createRadiodensityMeasurementEndpoint,
  updateRadiodensityMeasurementEndpoint,
  deleteRadiodensityMeasurementEndpoint,
} from "./api/RadiodensityMeasurements";

export const createRadiodensityMeasurementInDatabase = async measurementData => {
  try {
    const response = await createRadiodensityMeasurementEndpoint(measurementData);
    return response;
  } catch (error) {
    throw new Error(`Error creating radiodensity measurement: ${error.message}`);
  }
};

export const updateRadiodensityMeasurementInDatabase = async (measurementId, measurementData) => {
  try {
    const response = await updateRadiodensityMeasurementEndpoint(measurementId, measurementData);
    return response;
  } catch (error) {
    throw new Error(`Error updating radiodensity measurement: ${error.message}`);
  }
};

export const deleteRadiodensityMeasurementFromDatabase = async measurementId => {
  try {
    const response = await deleteRadiodensityMeasurementEndpoint(measurementId);
    return response;
  } catch (error) {
    throw new Error(`Error deleting radiodensity measurement: ${error.message}`);
  }
};
